export default __webpack_public_path__ + "static/media/bg.29582d5f.png";